handleApparelClothingThemeSettings();

function setANC(type) {
    if (type === "sorority" || type === "fraternity") {
        sessionStorage.setItem("navANC", type);
        return;
    }

    sessionStorage.setItem("navANC", "sorority");
}

function getANC() {
    return sessionStorage.getItem("navANC") || "sorority";
}

function handleApparelClothingThemeSettings() {
    const megaMenu = document.querySelector(".anc-mega");
    if (!megaMenu) return;

    const btns = [...megaMenu.querySelectorAll('button')];
    if (btns.length === 0) return;
    
    initButtons();
    setActive(btns, getANC());

    function initButtons() {
        btns.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                const btnType = btn.dataset.greekType;
                const ancStorage = getANC();
                
                if (ancStorage !== btnType) {
                    setActive(btns, btnType);
                }
            });
        });
    }

    function setActive(btns, type) {
        let prevClass, activeClass;
  
        switch (type) {
          case "fraternity":
            prevClass = "active-sorority";
            activeClass = "active-fraternity";
            break;

          case "sorority":
          default:
            prevClass = "active-fraternity";
            activeClass = "active-sorority";
            break;
        }
  
        setANC(type);
        megaMenu.classList.remove(prevClass);
        megaMenu.classList.add(activeClass);

        if (btns.length > 0) {
            const colorScheme = type === 'sorority' ? 'color-scheme-7' : 'color-scheme-5';

            [...btns].forEach((btn) => {
                if (btn.dataset.greekType === type) {
                    btn.className = `button button--secondary ${colorScheme}`;
                } else {
                    btn.className = 'button button--tertiary';
                }
            });
        }
    }
}